import { PUBLIC_EMAIL_DOMAINS } from '../constants/publicEmailDomains';

const PARTNER_BOUNDARY_ROLES = new Set([
  'External Requestor',
  'Partner Contributor',
  'Partner Contributor LVO',
]);

const PUBLIC_DOMAIN_SET = new Set(
  PUBLIC_EMAIL_DOMAINS.map(domain => domain.toLowerCase()),
);

const KNOWN_INTERNAL_ROLES = new Set([
  'Supervisor NAM',
  'Supervisor EMEA',
  'Supervisor APAC',
  'Requestor',
  'Vertiv Contributor',
  'Config Engineer',
  'Vertiv Sponsor',
  'IT Administrator',
  'Business Owner',
  'Role Manager',
  'Default Sponsor NAM',
  'Default Sponsor EMEA',
  'Default Sponsor APAC',
  'Impersonator Full Access',
  'Impersonator Read Only',
]);

export const extractViewerDomain = (email?: string | null): string | null => {
  if (typeof email !== 'string') {
    return null;
  }
  const trimmed = email.trim();
  if (
    !trimmed ||
    /[\s<>]/.test(trimmed) ||
    (trimmed.match(/@/g) ?? []).length !== 1
  ) {
    return null;
  }
  const at = trimmed.indexOf('@');
  const domain = trimmed.slice(at + 1).toLowerCase();
  if (
    !domain ||
    domain.startsWith('.') ||
    domain.endsWith('.') ||
    domain.includes('..') ||
    !domain.includes('.')
  ) {
    return null;
  }
  return domain;
};

export const isPublicViewerDomain = (domain: string): boolean => {
  const normalized = domain.trim().toLowerCase();
  if (PUBLIC_DOMAIN_SET.has(normalized)) {
    return true;
  }
  return [...PUBLIC_DOMAIN_SET].some(listed =>
    normalized.endsWith(`.${listed}`),
  );
};

export const isInternalPartnerViewer = (roles?: string[] | null): boolean => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }
  return roles.some(role => KNOWN_INTERNAL_ROLES.has(String(role).trim()));
};
